import React from 'react';

const Footer = () => {

    return (
        <div className="footer-wrapper dark-bg-with-gradients">
            <div className="footer-content-wrapper">
                <p style={{ textAlign: 'left' }}>Home page: <a href="https://lockedtrade.com">https://lockedtrade.com</a></p>
                <p style={{ textAlign: 'left' }}>Contact: <a href="mailto:office@lockedtrade.com">office@lockedtrade.com</a></p>
                <div style={{ borderTop: '1px solid #FFF', paddingTop: '15px', marginTop: '15px'}}>
                    <p style={{ textAlign: 'left' }}>© 2025 Locked Trade LLC. All rights reserved.</p>
                </div>
            </div>
        </div>
    )
}

export default Footer;